// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_tabs_2fm9BaI","bordered":"tabs_bordered_3-1Ufyp","tab":"tabs_tab_3n-3A9K","active":"tabs_active_3Mqc4Ib","disabled":"tabs_disabled_2Uuz-r6"};